export default "__VITE_ASSET__DqMJCX3K__"